<template>
  <v-card flat color="transparent" data-aos="fade">
    <v-img
      :height="imageHeight"
      :lazy-src="image.lazySrc"
      :src="image.src"
      position="center center"
    >
    </v-img>
    <h1 class="text-center">Contact Me</h1>
    <v-container class="mb-6">
      <v-row justify="space-around" class="get-in-touch">
        <v-col>
          <p>
            Do you have a question? A suggestion? A project you would like to discuss?
          </p>
          <p>
            Please send me a message via the form below or by <a :href="mailTo">email</a>.
            I look forward to receiving your enquiry!
          </p>
          <contact-form :subject="subject"></contact-form>
        </v-col>
      </v-row>
    </v-container>
  </v-card>
</template>

<script>
import {
  VCard,
  VCol,
  VContainer,
  VImg,
  VRow,
} from 'vuetify/lib'
import ContactForm from '../components/ContactForm'
import MetaInfoBuilder from '@/utils/social'

export default {
  components: {
    ContactForm,
    VCard,
    VCol,
    VContainer,
    VImg,
    VRow,
  },
  computed: {
    imageHeight() {
      switch (this.$vuetify.breakpoint.name) {
        case 'xs': return '250px'
        case 'sm': return '400px'
        case 'md': return '500px'
        case 'lg': return '600px'
        case 'xl': return '800px'
      }
      return '800px'
    },
    mailTo() {
      const mailTo = 'mailto:contact@chefnaturelle.com';

      return this.subject ? `${mailTo}?subject=${this.subject}` : mailTo;
    }
  },
  data: () => ({
    image: require('@/assets/images/contact-banner4.jpg?vuetify-preload'),
    title: 'Get In Touch',
  }),
  metaInfo() {
    return new MetaInfoBuilder()
      .description(this.title)
      .image(`${window.location.origin}${this.image.src}`)
      .title(this.title)
      .build()
  },
  props: {
    subject: {
      type: String,
      default: ''
    }
  }
}
</script>

<style lang="scss" scoped>
h1 {
  margin-top: 30px;
  font-family: 'Nanum Myeongjo', serif !important;
  font-size: 50px !important;
  color: rgba(0, 0, 0, 0.87);
}

.v-parallax h1 {
  text-shadow: 0 0 8px black;
}

.v-image h3 {
  color: white;
  font-size: 35px;
  line-height: 70px;
  text-align: center;
  text-shadow: 0 0 5px black;
}

.get-in-touch {
  margin-top: 5px;
}

.get-in-touch h3 {
  font-weight: normal;
  text-align: left;
  text-transform: uppercase;
}

.get-in-touch .hear-from p,
.get-in-touch .hear-from h3 {
  text-align: left;
}

.get-in-touch p {
  text-align: left;
}
</style>
